import {
    HomeIcon,
    ArrowPathIcon,
    AdjustmentsHorizontalIcon,
    CreditCardIcon,
    ArrowTrendingUpIcon,
    StarIcon,
    BeakerIcon,
    UsersIcon,
    ShieldCheckIcon,
    Cog6ToothIcon,
} from '@heroicons/react/24/outline';
import { NAVIGATION_BAR_DIVIDER } from '@clockout-dev/design-elements';
import { NAVBAR_PATHS } from './navbar.paths';
import { SCOPES } from '../../../constants/scopes.constants';
import SupportIcon from '../supportIcon/SupportIcon';

export { NAVBAR_PATHS, NAVBAR_BRAND_PATH, NAVBAR_ACTIVE_PATH_ALIASES } from './navbar.paths';

/** Figma Admin 3.0 «Sidebar» (78:10744) — fixed product line under the bank name. */
export const NAVBAR_BRAND_SUBTITLE = 'Clockout dashboard';

/** Figma «Bank card» / Close header logo — the Clockout mark. */
export const NAVBAR_LOGO_SRC = '/logo-mark.png';

/**
 * Sidebar items in Figma «Sidebar» order (78:10744, Support added in 661:32108);
 * a divider row splits the destinations from the account group (Team · Roles ·
 * Settings), and a second one sets Support apart at the end. Notifications
 * stays in the header (Figma «Navbar» 998:26872).
 */
export const navbarSections = [
    {
        id: 'dashboard',
        label: 'Home',
        path: NAVBAR_PATHS.dashboard,
        icon: <HomeIcon />,
        requiredScope: SCOPES.DASHBOARD_VIEW,
    },
    {
        id: 'treasury',
        label: 'Cashflow Management',
        path: NAVBAR_PATHS.treasury,
        icon: <ArrowPathIcon />,
        requiredScope: SCOPES.TREASURY_VIEW,
    },
    {
        id: 'configurations',
        label: 'Program Rules',
        path: NAVBAR_PATHS.configurations,
        icon: <AdjustmentsHorizontalIcon />,
        requiredScope: SCOPES.CONFIGURATIONS_VIEW,
    },
    {
        id: 'billing',
        label: 'Billing',
        path: NAVBAR_PATHS.billing,
        icon: <CreditCardIcon />,
        requiredScope: SCOPES.BILLING_VIEW,
    },
    {
        id: 'reports',
        label: 'Users & Transactions',
        path: NAVBAR_PATHS.reports,
        icon: <ArrowTrendingUpIcon />,
        requiredScope: SCOPES.REPORTS_VIEW,
    },
    {
        id: 'reviews',
        label: 'Reviews',
        path: NAVBAR_PATHS.reviews,
        icon: <StarIcon />,
        requiredScope: SCOPES.REVIEWS_VIEW,
    },
    {
        id: 'uploads-simulator',
        label: 'Uploads Simulator',
        path: NAVBAR_PATHS.uploadsSimulator,
        icon: <BeakerIcon />,
        requiredScope: SCOPES.UPLOADS_SIMULATOR_RUN,
    },
    { id: 'divider-account', type: NAVIGATION_BAR_DIVIDER },
    {
        id: 'team',
        label: 'Team',
        path: NAVBAR_PATHS.team,
        icon: <UsersIcon />,
        requiredScope: SCOPES.TEAM_VIEW,
    },
    {
        id: 'roles',
        label: 'Roles',
        path: NAVBAR_PATHS.roles,
        icon: <ShieldCheckIcon />,
        requiredScope: SCOPES.ROLES_VIEW,
    },
    // Unscoped: every authenticated FI member manages their own account
    // (account.js has no `scope` on its <Page>).
    {
        id: 'settings',
        label: 'Settings',
        path: NAVBAR_PATHS.account,
        icon: <Cog6ToothIcon />,
    },
    { id: 'divider-support', type: NAVIGATION_BAR_DIVIDER },
    {
        id: 'support',
        label: 'Support',
        path: NAVBAR_PATHS.support,
        icon: <SupportIcon />,
        requiredScope: SCOPES.SUPPORT_VIEW,
        landing: false,
    },
];
